import { EnumType } from './enum-type';

export class Property {
    public name: string;
    public value: string;
    public legacy: boolean;
    public legacyable: boolean;
    public readonly: boolean;
    public type: EnumType;
}
